import axios from 'axios'
import { eventBus } from '@/eventBus'

let sessionExpiredEmitted = false
export const resetSessionFlag = () => { sessionExpiredEmitted = false }

const IGNORE_401 = [
  '/api/auth/login',
  '/api/auth/logout',
  '/api/extranet/auth/login',
  '/api/extranet/auth/logout',
  '/api/member/login',
  '/api/member/logout',
  '/api/backoffice/login',
  '/api/backoffice/logout'
]

const getPath = (url = '') => url.split('?')[0].replace(/^https?:\/\/[^/]+/, '')

export function setupAxiosInterceptor() {
  axios.interceptors.response.use(
    (res) => res,
    (error) => {
      // Offline / timeout: tidak ada response, sesi tetap valid
      if (!error.response) return Promise.reject(error)

      if (error.response.status === 401) {
        const auth = error.config?.headers?.Authorization
        const hadToken = typeof auth === 'string' && auth.length > 'Bearer '.length
        const ignored = IGNORE_401.includes(getPath(error.config?.url))
        const stillLoggedIn = !!localStorage.getItem('token')

        if (hadToken && stillLoggedIn && !ignored && !sessionExpiredEmitted) {
          sessionExpiredEmitted = true
          eventBus.emit('session-expired')
        }
      }
      return Promise.reject(error)
    }
  )
}